import {faAngleLeft, faPlus} from '@fortawesome/free-solid-svg-icons';
import {useTheme} from 'styled-components';
import BigBoldBlueTextInline from './BigBoldBlueTextInline';
import EqualTwoTextInputs from './EqualTwoTextInputs';
import {FontIcon} from './FontIcon';
import MyView from './MyView';
import PhoneView from './PhoneView';
import SimpleText from './SimpleText';
import {styles} from './styles.js';

const CommonWebBox = props => {
  const theme = useTheme();
  const style1 = {
    direction: 'rtl',
    padding: 10,
    width: props.width !== undefined ? props.width : 'auto',
  };

  const allStyle = props.style
    ? {...style1, ...props.style, backgroundColor: 'unset'}
    : {...style1};

  return (
    <MyView style={allStyle}>
      <MyView
        style={{
          overflow: props.rowId ? 'hidden' : 'visible',
          background:
            props.style?.backgroundColor &&
            props.style?.backgroundColor.indexOf('linear-gradient') !== -1
              ? props.style?.backgroundColor
              : undefined,
          backgroundColor: props.style?.backgroundColor
            ? props.style.backgroundColor
            : theme.name !== 'dark'
            ? theme.colors.background.modal
            : 'unset',
          padding: props?.style?.padding ?? 10,
          ...props.childStyle,
          boxShadow:
            theme.name !== 'dark' || props.style?.backgroundColor
              ? '0px 3px 16px 4px rgb(0 0 0 / 16%)'
              : 'unset',
          borderRadius: 10,
          gap: props.no_gap === undefined || !props.no_gap ? 15 : 0,
        }}>
        {props.rowId !== undefined && (
          <>
            <PhoneView
              style={{
                ...styles.circleBoxUp,
              }}>
              <SimpleText
                style={{
                  ...styles.circleNumberBox,
                }}
                text={props.rowId}
              />
            </PhoneView>
            <PhoneView
              style={{
                ...styles.circleBoxDown,
              }}></PhoneView>
          </>
        )}
        {props.header && (
          <EqualTwoTextInputs>
            <BigBoldBlueTextInline
              style={{
                marginRight: props.rowId !== undefined ? 45 : 0,
              }}
              text={props.header}
            />
            {props.btn && props.btn}
            {(props.addBtn || props.backBtn) && (
              <PhoneView style={{gap: 10, marginBottom: 10, text: 'center'}}>
                {props.addBtn && props.addBtn && (
                  <FontIcon
                    onPress={props.onAddClick}
                    theme="rect"
                    kind="normal"
                    back={'yellow'}
                    icon={faPlus}
                  />
                )}
                {props.backBtn && props.backBtn && (
                  <FontIcon
                    onPress={props.onBackClick}
                    theme="rect"
                    kind="normal"
                    icon={faAngleLeft}
                  />
                )}
              </PhoneView>
            )}
          </EqualTwoTextInputs>
        )}
        {props.child !== undefined && props.child}
        {props.children !== undefined && props.children}
      </MyView>
    </MyView>
  );
};

export default CommonWebBox;
